import { VoucherForm } from './types';

const purchaseIcon = 'assets/voucher/type_icon/purchase_discount.png';
const shippingIcon = 'assets/voucher/type_icon/shipping_discount.png';

export const voucherModes: { [key: string]: VoucherForm } = {
  default: {
    title: 'Create Voucher',
    isGeneric: false,
    quantityDefault: null,
    backButton: true,
    specialField: 'generateCode',
    bannerField: true,
    affiliateField: true,
    createSpecsButton: false,
    publishButton: true
  },
  'voucher-spec': {
    title: 'Create Voucher Spec',
    isGeneric: false,
    quantityDefault: null,
    backButton: true,
    specialField: 'none',
    bannerField: false,
    affiliateField: false,
    createSpecsButton: true,
    publishButton: false
  },
  generic: {
    title: 'Create Voucher',
    quantityDefault: 1,
    isGeneric: true,
    backButton: true,
    specialField: 'quantity',
    bannerField: true,
    affiliateField: true,
    createSpecsButton: false,
    publishButton: true
  }
};

export const constants = {
  purchaseIcon,
  shippingIcon
};
